import { Text, View, StyleSheet } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";

function SFRSoilHealthStatus({ soilData, recommendation }) {
  const { t } = useTranslation();

  return (
    <>
      <Text style={styles.sectionTitle}>{t("soil.soilHealthStatus")}</Text>
      <View style={styles.grid}>
        {/* pH */}
        <View style={styles.gridItem}>
          <Text style={styles.label}>pH</Text>
          <Text style={styles.value}>
            {recommendation?.ph?.statusKey
              ? t(recommendation.ph.statusKey, recommendation.ph.statusParams)
              : recommendation?.ph?.status}
          </Text>
          <Text style={styles.valueSecondary}>{soilData?.avg_ph?.toFixed(2) || "N/A"}</Text>
        </View>

        {/* SOC */}
        <View style={styles.gridItem}>
          <Text style={styles.label}>SOC</Text>
          <Text style={styles.value}>
            {recommendation?.soc?.statusKey
              ? t(recommendation.soc.statusKey, recommendation.soc.statusParams)
              : recommendation?.soc?.status}
          </Text>
          <Text style={styles.valueSecondary}>{soilData?.avg_soc?.toFixed(2) || "N/A"} g/kg</Text>
        </View>

        {/* Nitrogen */}
        <View style={styles.gridItem}>
          <Text style={styles.label}>Nitrogen (N)</Text>
          <Text style={styles.value}>
            {recommendation?.nitrogen?.statusKey
              ? t(recommendation.nitrogen.statusKey, recommendation.nitrogen.statusParams)
              : recommendation?.nitrogen?.status}
          </Text>
          <Text style={styles.valueSecondary}>
            {soilData?.avg_nitrogen?.toFixed(2) || "N/A"} g/kg
          </Text>
        </View>

        {/* Phosphorus */}
        <View style={styles.gridItem}>
          <Text style={styles.label}>Phosphorus (P)</Text>
          <Text style={styles.value}>
            {recommendation?.phosphorus?.statusKey
              ? t(recommendation.phosphorus.statusKey, recommendation.phosphorus.statusParams)
              : recommendation?.phosphorus?.status}
          </Text>
          <Text style={styles.valueSecondary}>
            {soilData?.avg_phosphorus?.toFixed(2) || "N/A"} mg/kg
          </Text>
        </View>

        {/* Potassium */}
        <View style={styles.gridItem}>
          <Text style={styles.label}>Potassium (K)</Text>
          <Text style={styles.value}>
            {recommendation?.potassium?.statusKey
              ? t(recommendation.potassium.statusKey, recommendation.potassium.statusParams)
              : recommendation?.potassium?.status}
          </Text>
          <Text style={styles.valueSecondary}>
            {soilData?.avg_potassium?.toFixed(2) || "N/A"} cmol/kg
          </Text>
        </View>
      </View>
    </>
  );
}

export default SFRSoilHealthStatus;

const styles = StyleSheet.create({
  sectionTitle: {
    fontSize: 13,
    fontWeight: "bold",
    marginBottom: 8,
  },
  grid: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 8,
    marginBottom: 12,
  },
  gridItem: {
    width: "45%",
    padding: 8,
    border: "1px solid #e2e8f0",
    borderRadius: 4,
    backgroundColor: "#f8fafc",
  },
  label: {
    fontSize: 9,
    color: "#64748b",
    marginBottom: 2,
  },
  value: {
    fontSize: 11,
    fontWeight: "bold",
  },
  valueSecondary: {
    fontSize: 9,
    color: "#64748b",
  },
});
